import cn from 'classnames/bind';
import { range } from 'ramda';
import React, { FC, PropsWithChildren, Ref, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import styles from './FadedList.module.css';

interface Props {
    setElementRef?: Ref<HTMLDivElement>;
    className: string;
    off?: boolean;
}

const cx = cn.bind(styles);

const THRESHOLDS = range(0, 11).map((item) => item / 10);

const FadedList: FC<PropsWithChildren<Props>> = ({ className, setElementRef, off, children }) => {
    const [topShadowOpacity, setTopShadowOpacity] = useState(0);
    const [bottomShadowOpacity, setBottomShadowOpacity] = useState(0);

    const [topShadowRef, , topShadowEntry] = useInView({
        threshold: THRESHOLDS,
    });
    const [bottomShadowRef, , bottomShadowEntry] = useInView({
        threshold: THRESHOLDS,
    });

    useEffect(() => {
        const intersectionRatio = Number(topShadowEntry?.intersectionRatio?.toFixed(1)) || 0;
        setTopShadowOpacity(1 - (intersectionRatio > 1 ? 1 : intersectionRatio));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [topShadowEntry?.intersectionRatio]);

    useEffect(() => {
        const intersectionRatio = Number(bottomShadowEntry?.intersectionRatio?.toFixed(1)) || 0;
        setBottomShadowOpacity(1 - (intersectionRatio > 1 ? 1 : intersectionRatio));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bottomShadowEntry?.intersectionRatio]);

    return (
        <div className={cx('big-container')}>
            {!off && <div style={{ opacity: topShadowOpacity }} className={cx('top-shadow')} />}
            <div ref={setElementRef} className={cx('container')}>
                <div className={className}>
                    <div ref={topShadowRef} className={cx('top-border')} />
                    {children}
                    <div ref={bottomShadowRef} className={cx('bottom-border')} />
                </div>
            </div>
            {!off && (
                <div style={{ opacity: bottomShadowOpacity }} className={cx('bottom-shadow')} />
            )}
        </div>
    );
};

export default FadedList;
